import { render } from "./OrderProductsTable.vue?vue&type=template&id=17006326&scoped=true"
import script from "./OrderProductsTable.vue?vue&type=script&lang=js"
export * from "./OrderProductsTable.vue?vue&type=script&lang=js"

import "./OrderProductsTable.vue?vue&type=style&index=0&id=17006326&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17006326"]])

export default __exports__